import React, { useState, useEffect, useCallback } from "react";
import { debounce } from "lodash";

function OTPInputWithTimer({
  onOtpChange,
  onLoadingChange,
  initialTime = 30,
  postCode,
  userId,
}) {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [isRequestDisabled, setIsRequestDisabled] = useState(true);

  // Handle change of individual input
  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      onOtpChange(newOtp.join(""));
      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  // Handle paste
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setOtp(pasteData.split(""));
      onOtpChange(pasteData);
    }
    event.preventDefault();
  };

  // Countdown timer
  useEffect(() => {
    const timer =
      timeLeft > 0 && setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  // Handle "Request OTP" click
  const handleRequestOTP = useCallback(
    debounce((e) => {
      setTimeLeft(300);
      onLoadingChange(true);
      postCode(e);
      setIsRequestDisabled(true);
    }, 0), // Debounce time
    [] // Dependencies
  );

  return (
    <div>
      <div className="flex w-full flex-col items-center justify-between">
        <div
          onPaste={handlePaste}
          className="flex w-full gap-2 mb-2 flex-nowrap justify-between"
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              id={`otp-input-${index}`}
              type="text"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
            dark:bg-[#101010] ${
              digit ? "border-[#003478]" : "grey"
            } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
            input-main`}
            />
          ))}
        </div>
      </div>
      <div className="flex items-center pt-4 justify-between mb-6">
        <div className="flex items-center">
          <p className="text-sm font-medium after-login">
            Didn't receive a code?{" "}
            <span className="text-black font-semibold">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
        <a
          onClick={(e) => {
            e.preventDefault();
            setOtp(new Array(6).fill(""));
            onOtpChange("");
            handleRequestOTP(e);
          }}
          href="#"
          className=" text-sm font-semibold text-decoration after-login hover:underline"
        >
          Request OTP
        </a>
      </div>
    </div>
  );
}

export default OTPInputWithTimer;
